import barba from '@barba/core';
import { gsap } from 'gsap';
import { EventDispatcher } from './EventDispatcher.js';

let duration_Overlay = 0.35;

export default class PageFlipController {
    constructor() {
        const self = this;

        barba.init({
            debug: false,
            transitions: [
                {
                    name: 'opacity-transition',

                    leave(data) {
                        // console.log('leave');

                        EventDispatcher.emit('pageTransition', {
                            namespace: 'leave',
                        });

                        gsap.killTweensOf(data.current.container);

                        if (data.trigger === 'back' || data.trigger === 'forward') {
                            duration_Overlay = 0.01;
                        } else {
                            duration_Overlay = 0.45;
                        }

                        return gsap.to(data.current.container, {
                            opacity: 0,
                            duration: duration_Overlay,
                        });
                    },

                    afterLeave(data) {
                        // console.log('afterLeave');

                        EventDispatcher.emit('pageTransition', {
                            namespace: 'afterLeave',
                        });
                    },

                    enter(data) {
                        // console.log('enter');

                        if ('scrollRestoration' in history) {
                            history.scrollRestoration = 'manual';
                        }

                        EventDispatcher.emit('pageTransition', {
                            namespace: 'enter',
                            container: data.next.container,
                        });
                    },

                    after(data) {
                        // console.log('after');

                        EventDispatcher.emit('pageTransition', {
                            namespace: 'after',
                            container: data.next.container,
                        });

                        gsap.from(data.next.container, {
                            opacity: 0,
                            duration: 0.55,
                            onComplete: () => {},
                        });
                    },

                    afterEnter(data) {
                        // console.log('afterEnter');

                        EventDispatcher.emit('pageTransition', {
                            namespace: 'afterEnter',
                        });
                    },

                    once(data) {
                        //console.log('once');

                        EventDispatcher.emit('pageTransition', {
                            namespace: 'once',
                            container: data.next.container,
                        });

                        return gsap.to(data.next.container, {
                            opacity: 1,
                            duration: 0.55,
                        });
                    },
                },
            ],
        });

        this.initDoubleclickController();
    }

    initDoubleclickController() {
        document.addEventListener(
            'click',
            (e) => {
                if (barba.transitions.isRunning) {
                    //console.log('RUNNNNNING');

                    e.preventDefault();
                    e.stopImmediatePropagation();
                }
            },
            true
        );
    }
}
